import { defineComponent as _defineComponent } from 'vue'
import AzCheckbox from '~/components/_next/atoms/AzCheckbox.vue';

export type FilterProps = {
  label: string;
  selected?: boolean;
  disabled?: boolean;
  count?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AzFilter',
  props: {
    label: null,
    selected: { type: Boolean },
    disabled: { type: Boolean },
    count: null
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  selected?: boolean;
  disabled?: boolean;
  count?: number;
};



return { __sfc: true,props, AzCheckbox }
}

})